import utils from "../../components/search/details/download/utils/utils";
import objectUtils from "./objectUtils";
import DeviceCacheHelper from "../../components/devices/addDevice/helpers/deviceCacheHelper/DeviceCacheHelper";
import { FREYA_LOGGING_SOURCE } from "../constants";
import { FailedScannedBadgeState, DatelessEvent, IPersonBadge } from "../types";
import { LogResult } from "common/enums";

const logBadgePrintSuccessEvent = async (badgeInfo: IPersonBadge, logEvent: (event: DatelessEvent, deviceId?: string) => void) => {
  const { id, customerType, productCode } = badgeInfo;
  const parsedQrCodeContent = utils.parseQRCodeString(badgeInfo.qrCodeContent, customerType);

  const deviceId = await DeviceCacheHelper.getCachedInstanceId();
  const event = {
    source: FREYA_LOGGING_SOURCE,
    badgeId: id,
    customerType,
    productCode,
    badgeVersion: parsedQrCodeContent?.badgeVersion,
    deviceId,
    result: LogResult.True
  };
  logEvent(event, deviceId);
};

const logBadgePrintFailEvent = async (state: FailedScannedBadgeState | null, logEvent: (event: DatelessEvent, deviceId?: string) => void) => {
  // Handle null/invalid state gracefully
  if (!state) {
    return;
  }

  const { badgeInfo, reasonCode, reasonCodeValues } = state;
  
  // Handle null/invalid badgeInfo gracefully
  if (!badgeInfo) {
    const deviceId = await DeviceCacheHelper.getCachedInstanceId();
    const event = {
      source: FREYA_LOGGING_SOURCE,
      badgeId: 'unknown',
      customerType: 'unknown',
      productCode: 'unknown',
      badgeVersion: 'unknown',
      deviceId,
      result: LogResult.False,
      reasonCode: reasonCode || 'INVALID_STATE',
      reasonCodeValues: undefined // Always undefined when badgeInfo is null
    };
    
    logEvent(event, deviceId);
    return;
  }

  const { id, customerType, productCode } = badgeInfo;

  const parsedQrCodeContent = utils.parseQRCodeString(badgeInfo.qrCodeContent, customerType);
  const parsedReasonCodeValues = objectUtils.serializeObjectToKeyValuePairs(reasonCodeValues);

  const deviceId = await DeviceCacheHelper.getCachedInstanceId();
  const event = {
    source: FREYA_LOGGING_SOURCE,
    badgeId: id,
    customerType,
    productCode,
    badgeVersion: parsedQrCodeContent?.badgeVersion,
    deviceId,
    result: LogResult.False,
    reasonCode,
    reasonCodeValues: parsedReasonCodeValues
  };

  logEvent(event, deviceId);
};

const loggingUtils = { logBadgePrintSuccessEvent, logBadgePrintFailEvent };

export default loggingUtils;
